import { Component } from '@angular/core';

@Component({
  selector: 'ptl-skeleton-table-small-item',
  templateUrl: './skeleton-table-small-item.component.html',
  styleUrls: ['./skeleton-table-small-item.component.scss'],
})
export class SkeletonTableSmallItemComponent {}
